import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';

export const isNative = Capacitor.isNativePlatform();

export async function initCapacitor() {
  if (!isNative) {
    console.log('[CAPACITOR]: Running in Web / PWA browser environment.');
    return;
  }

  try {
    // Edge-to-edge dark tactical styling
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0a0c10' });

    // Handle Android hardware back button
    App.addListener('backButton', ({ canGoBack }) => {
      const openModals = document.querySelectorAll('.tactical-modal-overlay');
      let closedModal = false;
      openModals.forEach(m => {
        if (m.style.display !== 'none' && !m.classList.contains('hidden')) {
          m.style.display = 'none';
          closedModal = true;
        }
      });
      if (closedModal) return;

      if (canGoBack) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });

    console.log('[CAPACITOR]: Native mobile runtime initialized successfully.');
  } catch (err) {
    console.warn('[CAPACITOR]: Native initialization warning:', err);
  }
}

export async function hapticImpact(style = 'heavy') {
  if (!isNative) return;
  try {
    const s = style === 'heavy' ? ImpactStyle.Heavy : style === 'medium' ? ImpactStyle.Medium : ImpactStyle.Light;
    await Haptics.impact({ style: s });
  } catch (e) {}
}

export async function hapticNotification(type = 'success') {
  if (!isNative) return;
  try {
    const t = type === 'success' ? NotificationType.Success : type === 'warning' ? NotificationType.Warning : NotificationType.Error;
    await Haptics.notification({ type: t });
  } catch (e) {}
}
